import { render } from "./cibrFileUpload.vue?vue&type=template&id=1b3303de"
import script from "./cibrFileUpload.vue?vue&type=script&lang=js"
export * from "./cibrFileUpload.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__